import { render, staticRenderFns } from "./addpersonnel.vue?vue&type=template&id=38f9645e&scoped=true"
import script from "./addpersonnel.vue?vue&type=script&lang=js"
export * from "./addpersonnel.vue?vue&type=script&lang=js"
import style0 from "./addpersonnel.vue?vue&type=style&index=0&id=38f9645e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f9645e",
  null
  
)

export default component.exports